// get_product_subcategory_faq
export const GET_PRODUCT_SUBCATEGORY_FAQ = 'get_product_subcategory_faq';
export const GET_PRODUCT_SUBCATEGORY_FAQ_SUCCESSFUL =
  'get_product_subcategory_faq_successfull';
export const GET_PRODUCT_SUBCATEGORY_FAQ_FAILED =
  'get_product_subcategory_faq_failed';

// create_product_subcategory_faq
export const CREATE_PRODUCT_SUBCATEGORY_FAQ = 'create_product_subcategory_faq';
export const CREATE_PRODUCT_SUBCATEGORY_FAQ_SUCCESSFUL =
  'create_product_subcategory_faq_successfull';
export const CREATE_PRODUCT_SUBCATEGORY_FAQ_FAILED =
  'create_product_subcategory_faq_failed';

// update_product_subcategory_faq
export const UPDATE_PRODUCT_SUBCATEGORY_FAQ = 'update_product_subcategory_faq';
export const UPDATE_PRODUCT_SUBCATEGORY_FAQ_SUCCESSFUL =
  'update_product_subcategory_faq_successfull';
export const UPDATE_PRODUCT_SUBCATEGORY_FAQ_FAILED =
  'update_product_subcategory_faq_failed';

// delete_product_subcategory_faq
export const DELETE_PRODUCT_SUBCATEGORY_FAQ = 'delete_product_subcategory_faq';
export const DELETE_PRODUCT_SUBCATEGORY_FAQ_SUCCESSFUL =
  'delete_product_subcategory_faq_successfull';
export const DELETE_PRODUCT_SUBCATEGORY_FAQ_FAILED =
  'delete_product_subcategory_faq_failed';

// exchange_product_subcateory_faq_order
export const EXCHANGE_PRODUCT_SUBCATEORY_FAQ_ORDER =
  'exchange_product_subcateory_faq_order';
export const EXCHANGE_PRODUCT_SUBCATEORY_FAQ_ORDER_SUCCESSFUL =
  'exchange_product_subcateory_faq_order_successfull';
export const EXCHANGE_PRODUCT_SUBCATEORY_FAQ_ORDER_FAILED =
  'exchange_product_subcateory_faq_order_failed';
